import { render, staticRenderFns } from "./ContaServico.vue?vue&type=template&id=39e49ecf&scoped=true"
import script from "./ContaServico.vue?vue&type=script&lang=js"
export * from "./ContaServico.vue?vue&type=script&lang=js"
import style0 from "./ContaServico.vue?vue&type=style&index=0&id=39e49ecf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e49ecf",
  null
  
)

export default component.exports